import React, { useState, useEffect, useContext } from 'react';
import moment from "moment";
import Wallpaper from '../assets/vice-city.jpg';
import Wallpaper2 from '../assets/ViceCity2.png';
import LuciaAndJason from '../assets/lucia-and-jason.png';
import LuciaAndJason2 from '../assets/LuciaJason2.png';
import { Theme } from '../App';

export default function Background() {
    const { theme } = useContext(Theme);
    const targetTime = moment("2026-11-19");
    const [ref, setRef] = useState('full');
    const [currentTime, setCurrentTime] = useState(moment());
    const timeRemaining = {
        'full': moment.duration(targetTime.diff(currentTime)),
        'months': moment(targetTime).diff(Date.now(), 'months'),
        'weeks': moment(targetTime).diff(Date.now(), 'weeks'),
        'days': moment(targetTime).diff(Date.now(), 'days'),
        'hours': moment(targetTime).diff(Date.now(), 'hours'),
        'minutes': moment(targetTime).diff(Date.now(), 'minutes'),
        'seconds': moment(targetTime).diff(Date.now(), 'seconds'),
    };

    useEffect(() => {
        const interval = setInterval(() => {
            setCurrentTime(moment());
        }, 1000);

        return () => clearInterval(interval);
    }, []);

    const [touchStart, setTouchStart] = useState(null);
    const [touchEnd, setTouchEnd] = useState(null);
    const minSwipeDistance = 50

    const onTouchStart = (e) => {
        setTouchEnd(null);
        setTouchStart(e.targetTouches[0].clientX);
    }

    const onTouchMove = (e) => setTouchEnd(e.targetTouches[0].clientX)

    const onTouchEnd = () => {
        if (!touchStart || !touchEnd) return
        const distance = touchStart - touchEnd
        const isLeftSwipe = distance > minSwipeDistance
        const isRightSwipe = distance < -minSwipeDistance
        if (isLeftSwipe || isRightSwipe) {
            if (ref === 'full') {
                setRef(isLeftSwipe ? 'months' : 'seconds');
            } else if (ref === 'months') {
                setRef(isLeftSwipe ? 'weeks' : 'full');
            } else if (ref === 'weeks') {
                setRef(isLeftSwipe ? 'days' : 'months');
            } else if (ref === 'days') {
                setRef(isLeftSwipe ? 'hours' : 'weeks');
            } else if (ref === 'hours') {
                setRef(isLeftSwipe ? 'minutes' : 'days');
            } else if (ref === 'minutes') {
                setRef(isLeftSwipe ? 'seconds' : 'hours');
            } else if (ref === 'seconds') {
                setRef(isLeftSwipe ? 'full' : 'minutes');
            }
        }
    }

    const onChangeData = (type) => {
        setRef(type);
    }

    return (
        <div className="background"
            onTouchStart={onTouchStart}
            onTouchMove={onTouchMove}
            onTouchEnd={onTouchEnd}>
            {timeRemaining['seconds'] >= 0 &&
                <div className="background__pagination">
                    <button className={`background__pagination__button ${ref === 'full' ? 'active' : ''}`} onClick={() => onChangeData('full')}></button>
                    <button className={`background__pagination__button ${ref === 'months' ? 'active' : ''}`} onClick={() => onChangeData('months')}></button>
                    <button className={`background__pagination__button ${ref === 'weeks' ? 'active' : ''}`} onClick={() => onChangeData('weeks')}></button>
                    <button className={`background__pagination__button ${ref === 'days' ? 'active' : ''}`} onClick={() => onChangeData('days')}></button>
                    <button className={`background__pagination__button ${ref === 'hours' ? 'active' : ''}`} onClick={() => onChangeData('hours')}></button>
                    <button className={`background__pagination__button ${ref === 'minutes' ? 'active' : ''}`} onClick={() => onChangeData('minutes')}></button>
                    <button className={`background__pagination__button ${ref === 'seconds' ? 'active' : ''}`} onClick={() => onChangeData('seconds')}></button>
                </div>
            }
            <img className={`background__foreground ${theme} ${timeRemaining['seconds'] < 0 ? 'out' : ''}`}
                src={theme === "blue" ? LuciaAndJason2 : LuciaAndJason}
                alt="Lucia and Jason are on a car in the street." />
            <img className={`background__wallpaper ${theme}`}
                src={theme === "blue" ? Wallpaper2 : Wallpaper}
                alt="A Vice city landscape with buildings and palmtrees." />
            <img className="background__background"
                src={theme === "blue" ? Wallpaper2 : Wallpaper}
                alt="A Vice city landscape with buildings and palmtrees." />
            {timeRemaining['seconds'] < 0 ?
                <div className={`background__countdown ${theme}`}>
                    <p className={`background__countdown__label out desktop ${theme}`}>
                        The game <br />of the century<br /> is now available.
                    </p>
                    <p className={`background__countdown__label out mobile ${theme}`}>
                        The game <br />of the century<br /> is now<br /> available.
                    </p>
                </div>
                : <div className={`background__countdown ${theme} ${timeRemaining[ref] > 99999 && ref !== 'full' ? "long" : ""} ${ref === 'full' ? "extralong" : ""}`}>
                    <p className={`background__countdown__label ${theme}`}>
                        {ref !== 'full' ?
                            <React.Fragment>
                                {ref} to survive
                            </React.Fragment>
                            : 'Complete time to survive'
                        }
                    </p>
                    <p className={`background__countdown__number ${theme} ${timeRemaining[ref] > 99999 && ref !== 'full' ? "long" : ""} ${ref === 'full' ? "extralong" : ""}`}>
                        {ref !== 'full' ?
                            <React.Fragment>
                                {timeRemaining[ref]}
                            </React.Fragment>
                            : <React.Fragment>
                                <div className="background__full">
                                    <div className="background__full__item">
                                        <span className="background__full__item__number">
                                            {timeRemaining[ref].years().toString().padStart(2, '0')}
                                        </span>
                                        <span className="background__full__item__label">
                                            year{timeRemaining[ref].years() > 1 ? 's' : ''}
                                        </span>
                                    </div>
                                    <span className="background__full__separator">
                                        :
                                    </span>
                                    <div className="background__full__item">
                                        <span className="background__full__item__number">
                                            {timeRemaining[ref].months().toString().padStart(2, '0')}
                                        </span>
                                        <span className="background__full__item__label">
                                            month{timeRemaining[ref].months() > 1 ? 's' : ''}
                                        </span>
                                    </div>
                                    <span className="background__full__separator">
                                        :
                                    </span>
                                    <div className="background__full__item">
                                        <span className="background__full__item__number">
                                            {timeRemaining[ref].days().toString().padStart(2, '0')}
                                        </span>
                                        <span className="background__full__item__label">
                                            day{timeRemaining[ref].days() > 1 ? 's' : ''}
                                        </span>
                                    </div>
                                    <span className="background__full__separator">
                                        :
                                    </span>
                                    <div className="background__full__item">
                                        <span className="background__full__item__number">
                                            {timeRemaining[ref].hours().toString().padStart(2, '0')}
                                        </span>
                                        <span className="background__full__item__label">
                                            hour{timeRemaining[ref].hours() > 1 ? 's' : ''}
                                        </span>
                                    </div>
                                    <span className="background__full__separator">
                                        :
                                    </span>
                                    <div className="background__full__item">
                                        <span className="background__full__item__number">
                                            {timeRemaining[ref].minutes().toString().padStart(2, '0')}
                                        </span>
                                        <span className="background__full__item__label">
                                            minute{timeRemaining[ref].minutes() > 1 ? 's' : ''}
                                        </span>
                                    </div>
                                    <span className="background__full__separator">
                                        :
                                    </span>
                                    <div className="background__full__item">
                                        <span className="background__full__item__number">
                                            {timeRemaining[ref].seconds().toString().padStart(2, '0')}
                                        </span>
                                        <span className="background__full__item__label">
                                            second{timeRemaining[ref].seconds() > 1 ? 's' : ''}
                                        </span>
                                    </div>
                                </div>
                            </React.Fragment>
                        }
                    </p>
                </div>
            }
        </div>
    )
}